"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeedmapsAltUrl = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let WeedmapsAltUrl = class WeedmapsAltUrl {
};
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], WeedmapsAltUrl.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: false }),
    tslib_1.__metadata("design:type", String)
], WeedmapsAltUrl.prototype, "value", void 0);
WeedmapsAltUrl = tslib_1.__decorate([
    (0, typeorm_1.Entity)()
], WeedmapsAltUrl);
exports.WeedmapsAltUrl = WeedmapsAltUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VlZG1hcHNBbHRVcmwuanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL3dlZWRtYXBzQWx0VXJsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUU7QUFHMUQsSUFBTSxjQUFjLEdBQXBCLE1BQU0sY0FBYztDQVExQixDQUFBO0FBTkc7SUFBQyxJQUFBLGdDQUFzQixHQUFFOzswQ0FDZDtBQUVYO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLEtBQUssRUFBRSxDQUFDOzs2Q0FDZDtBQU5MLGNBQWM7SUFEMUIsSUFBQSxnQkFBTSxHQUFFO0dBQ0ksY0FBYyxDQVExQjtBQVJZLHdDQUFjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29sdW1uLCBFbnRpdHksIFByaW1hcnlHZW5lcmF0ZWRDb2x1bW4gfSBmcm9tIFwidHlwZW9ybVwiO1xuXG5ARW50aXR5KClcbmV4cG9ydCBjbGFzcyBXZWVkbWFwc0FsdFVybCB7XG5cbiAgICBAUHJpbWFyeUdlbmVyYXRlZENvbHVtbigpXG4gICAgaWQ6IG51bWJlcjtcblxuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogZmFsc2UgfSlcbiAgICB2YWx1ZTogc3RyaW5nO1xuXG59XG4iXX0=